import React from "react";

const KategoriPageSkeleton: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 py-6 animate-pulse">
      {/* TITLE */}
      <div className="mb-6">
        <div className="h-4 w-40 bg-gray-200 rounded mb-2"></div>
        <div className="h-8 w-52 bg-gray-300 rounded"></div>
      </div>

      <div className="grid lg:grid-cols-3 gap-8">
        {/* LEFT CONTENT */}
        <div className="lg:col-span-2">
          <div className="grid md:grid-cols-2 gap-6">
            {[1, 2, 3, 4, 5, 6].map((i) => (
              <div key={i}>
                <div className="w-full h-[200px] bg-gray-300 rounded-lg"></div>

                <div className="mt-3 space-y-2">
                  <div className="h-5 w-full bg-gray-300 rounded"></div>
                  <div className="h-5 w-5/6 bg-gray-300 rounded"></div>
                  <div className="h-3 w-32 bg-gray-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>

          {/* PAGINATION */}
          <div className="flex justify-center mt-10 gap-2">
            {[1, 2, 3, 4].map((i) => (
              <div key={i} className="w-10 h-10 bg-gray-300 rounded"></div>
            ))}
          </div>
        </div>

        {/* SIDEBAR */}
        <div>
          <div className="flex items-center gap-3 mb-4 border-b pb-2">
            <div className="w-5 h-5 bg-gray-300 rounded"></div>
            <div className="h-5 w-40 bg-gray-300 rounded"></div>
          </div>

          <div className="space-y-4">
            {[1, 2, 3, 4, 5].map((i) => (
              <div key={i} className="flex gap-3">
                <div className="w-[80px] h-[60px] bg-gray-300 rounded"></div>

                <div className="flex-1 space-y-2">
                  <div className="h-4 w-full bg-gray-300 rounded"></div>
                  <div className="h-4 w-5/6 bg-gray-300 rounded"></div>
                  <div className="h-3 w-24 bg-gray-200 rounded"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default KategoriPageSkeleton;
